var _Array$isArray = require("@babel/runtime-corejs3/core-js/array/is-array");
function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;